export * from './template-editor-confirm.component';
